import React from "react";

function CompanyForm({
  newCompany,
  users,
  handleInputChange,
  handleTarifInputChange,
  handleSubmit,
  closeModal,
  handleToggleChange,
  formError,
}) {
    return (
        <form onSubmit={handleSubmit} className="form-field">
                {formError && <p style={{ color: "red" }}>{formError}</p>}
                <h4 className="title_tarif">Identification de la société</h4>
                <div className="btn-switch">
                <label className="switch" htmlFor="checkbox"> 
                  <input 
                  name="checkbox"
                  id="checkbox"
                  type="checkbox"
                  checked={newCompany.societe_a_facturer === "Oui"}
                  onChange={handleToggleChange} 

                  />
                  <span className="slider"></span>
                </label>

                  </div>
                <div className="flex">
                  <div className="input-group">
                    <label htmlFor="siret"> Siret </label>
                    <input
                      id="siret"
                      type="text"
                      name="siret"
                      value={newCompany.siret}
                      onChange={handleInputChange}
                      required
                      pattern="\d{14}"
                      title="Le SIRET doit contenir exactement 14 chiffres."
                      maxLength="14"
                      minLength="14"

                    />
                  </div>
                  <div className="input-group">
                    <label htmlFor="nom">Nom</label>
                    <input
                    id="nom"
                      type="text"
                      name="nom"
                      value={newCompany.nom}
                      onChange={handleInputChange}
                      required

                    />
                  </div>
                </div>
                <div className="flex">
                  <div className="input-group">
                    <label htmlFor="adresse"> Adresse </label>
                    <input
                      id="adresse"
                      type="text"
                      name="adresse"
                      value={newCompany.adresse}
                      onChange={handleInputChange}
                      required

                    />
                  </div>
                  <div className="input-group">
                    <label htmlFor="ville">Ville</label>
                    <input
                      id="ville"
                      type="text"
                      name="ville"
                      value={newCompany.ville}
                      onChange={handleInputChange}
                      required
                     
                    />
                  </div>
                </div>
                <div className="flex">
                  <div className="input-group">
                    <label htmlFor="code postal"> Code postal </label>
                    <input
                      id="code postal"
                      type="text"
                      name="code_postal"
                      value={newCompany.code_postal}
                      onChange={handleInputChange}
                      pattern="\d{5}"
                      title="Le code postal doit contenir exactement 5 chiffres."
                      maxLength="5"
                      minLength="5"
                      required

                    />
                  </div>
                  <div className="input-group">
                    <label htmlFor="email"> Email </label>
                    <input
                      id="email"
                      type="email"
                      name="email"
                      value={newCompany.email}
                      onChange={handleInputChange}
                      required

                    />
                  </div>
                </div>
                <h4 className="title_tarif">Référence interne</h4>
                <div className="flex">
                  <div className="input-group">
                    <label htmlFor="gestionnaire_nom">Gestionnaire</label>
                    <select
                      id="gestionnaire_nom"
                      name="gestionnaire_nom"
                      value={newCompany.gestionnaire || ""}
                      onChange={handleInputChange}
                      className="select-custom"
                      required
                    >²
                      <option value="">Sélectionner un gestionnaire</option>
                      {users.map((user) => (
                        <option key={user.id} value={user.id}>
                          {user.username}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="input-group">
                    <label htmlFor="societe gestionnaire">
                      Societe-gestionnaire
                    </label>
                    <select
                      id="societe gestionnaire"
                      name="societe_gestionnaire"
                      value={newCompany.societe_gestionnaire}
                      onChange={handleInputChange}
                      className="societe_gestionnaire select-custom"
                      required
                    >
                      <option value="8P">8P</option>
                      <option value="E2P">E2P</option>
                    </select>
                </div>
                </div>
                <div className="flex">
                  <div className="input-group">
                    <label htmlFor="compte"> Compte </label>
                    <input
                      id="compte"
                      type="text"
                      name="compte"
                      value={newCompany.compte}
                      onChange={handleInputChange}
                      required
                     
                    />
                  </div>
                  <div className="input-group">
                    <label htmlFor="compte_de_base"> Compte de base</label>
                  
                    <select
                      id="compte_de_base"
                      name="compte_de_base"
                      value={newCompany.compte_de_base}
                      onChange={handleInputChange}
                      className="societe_gestionnaire select-custom"
                      required
                    >
                      <option value="412">412</option>
                      <option value="411">411</option>
                    </select>
                  </div>
                </div>
                <div className="flex">
                  <div className="input-group">
                    <label htmlFor="entite_facturation">
                      Entité de facturation{" "}
                    </label>
                    <input
                      id="entite_facturation"
                      type="text"
                      name="entite_facturation"
                      value={newCompany.entite_facturation}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
                <h4 className="title_tarif">Tarification des prestations</h4>
           
                <div className="montant">
                  <div className="flex">
                    <div className="input-group">
                      <label htmlFor="tarif_unitaire_bulletin_unitaire">
                        {" "}
                        Bulletin
                      </label>
                      <input
                        id="tarif_unitaire_bulletin_unitaire"
                        type="text"
                        name="tarif_unitaire_bulletin_unitaire"
                        value={newCompany.tarif_unitaire_bulletin_unitaire?.toString().replace('.', ',') || ''}
                        onChange={handleTarifInputChange}
                        required
                      />
                    </div>
                    <div className="input-group">
                      <label htmlFor="tarif_teulade">Teulade</label>
                      <input
                        id="tarif_teulade"
                        type="text"
                        name="tarif_teulade"
                        value={newCompany.tarif_teulade?.toString().replace('.', ',') || ''}
                        onChange={handleTarifInputChange}
                        title="Le tarif teulade doit être au format chiffres"
                        required
                      />
                    </div>
                    <div className="input-group">
                      <label htmlFor="tarif_RC">Rupture conventionnelle</label>
                      <input
                        id="tarif_RC"
                        type="text"
                        name="tarif_RC"
                        value={newCompany.tarif_RC?.toString().replace('.', ',') || ''}
                        onChange={handleTarifInputChange}
                        title="Le tarif RC doit être au format chiffres."
                        required
                      />
                    </div>
                  </div>
                  <div className="flex">
                    <div className="input-group">
                      <label htmlFor="tarif_licenciement">Licenciement</label>
                      <input
                        id="tarif_licenciement"
                        type="text"
                        name="tarif_licenciement"
                        value={newCompany.tarif_licenciement?.toString().replace('.', ',') || ''}
                        onChange={handleTarifInputChange}
                        title="Le tarif licenciement doit être au format chiffres"
                        required
                      />
                    </div>
                    <div className="input-group">
                      <label htmlFor="tarif_contrat">Contrat</label>
                      <input
                        id="tarif_contrat"
                        type="text"
                        name="tarif_contrat"
                        value={newCompany.tarif_contrat?.toString().replace('.', ',') || ''}
                        onChange={handleTarifInputChange}
                        title="Le tarif contrat doit être au format chiffres"
                        required
                      />
                    </div>
                    <div className="input-group">
                      <label htmlFor="tarif_maladie">Maladie</label>
                      <input
                        id="tarif_maladie"
                        type="text"
                        name="tarif_maladie"
                        value={newCompany.tarif_maladie?.toString().replace('.', ',') || ''}
                        onChange={handleTarifInputChange}
                        title="Le tarif maladie doit être au format chiffres,"
                        required
                      />
                    </div>
                  </div>
                  <div className="flex">
                    <div className="input-group">
                      <label htmlFor="tarif_avenant">Avenant</label>
                      <input
                        id="tarif_avenant"
                        type="text"
                        name="tarif_avenant"
                        value={newCompany.tarif_avenant?.toString().replace('.', ',') || ''}
                        onChange={handleTarifInputChange}
                        title="Le tarif_avenant doit être au format chiffres"
                        required
                      />
                    </div>
                    <div className="input-group">
                      <label htmlFor="tarif_mission_excep">Mission excep</label>
                      <input
                        id="tarif_mission_excep"
                        type="text"
                        name="tarif_mission_excep"
                        value={newCompany.tarif_mission_excep?.toString().replace('.', ',') || ''}
                        onChange={handleTarifInputChange}
                        title="Le tarif mission excep doit être au format chiffres."
                        required
                      />
                    </div>
                    <div className="input-group">
                      <label htmlFor="tarif_stc">Solde tout compte</label>
                      <input
                        id="tarif_stc"
                        type="text"
                        name="tarif_stc"
                        value={newCompany.tarif_stc?.toString().replace('.', ',') || ''}
                        onChange={handleTarifInputChange}
                        title="Le tarif_stc doit être au format chiffres"
                        required
                      />
                    </div>
                    
                  </div>
                  <div className="flex">
                  <div className="input-group">
                      <label htmlFor="montant_ftc"> Montant FTC</label>
                      <input
                        id="montant_ftc"
                        type="text"
                        name="montant_ftc"
                        value={newCompany.montant_ftc?.toString().replace('.', ',') || ''}
                        onChange={handleTarifInputChange}
                        title="Le montant doit être au format chiffres"
                        required
                      />
                    </div>
                    <div className="input-group">
                      <label htmlFor="tarif_acces_silae"> Accès SILAE</label>
                      <input
                        id="tarif_acces_silae"
                        type="text"
                        name="tarif_acces_silae"
                        value={newCompany.tarif_acces_silae?.toString().replace('.', ',') || ''}
                        onChange={handleTarifInputChange}
                        title="Le montant doit être au format chiffres"
                        required
                      />
                    </div>

                  </div>
                  <div className="form-actions">
                    <button onClick={closeModal} className="cancel-button">
                      Fermer
                    </button>
                    <button type="submit" className="submit-button">
                      Sauvegarder
                    </button>
                  </div>
                </div>
              </form>
               );
            }
            
            export default CompanyForm;